module.exports = __webpack_public_path__ + "img/pin-location.53cf3aad.svg";